import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from '../../../shared/components/Alert';
import ContractForm from '../components/ContractForm';
import { useCreateContrato } from '../hooks';

export default function NovoContratoPage(): React.ReactElement {
  const navigate = useNavigate();
  const { mutate, isPending, isError, error } = useCreateContrato();

  return (
    <div className="p-4 sm:p-6 max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">Novo Contrato</h1>
        <p className="text-sm text-gray-500 mt-1">Preencha os dados para criar um novo contrato comercial.</p>
      </div>

      {isError && (
        <Alert variant="error">{(error as Error)?.message ?? 'Erro ao criar contrato.'}</Alert>
      )}

      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <ContractForm
          onSubmit={(values) =>
            mutate(values, {
              onSuccess: (created) => navigate(`/contratos/${created.id}`),
            })
          }
          isSubmitting={isPending}
          submitLabel="Criar Contrato"
        />
      </div>
    </div>
  );
}
